import Api from './api.service';

export default {
  get: () => Api.get('states'),
  search: (term = '') => Api.get(`states?filter[name]=${term}`),

};
